import { render, staticRenderFns } from "./object-transfer.vue?vue&type=template&id=65cfbcd2&scoped=true&"
import script from "./object-transfer.vue?vue&type=script&lang=js&"
export * from "./object-transfer.vue?vue&type=script&lang=js&"
import style0 from "./object-transfer.vue?vue&type=style&index=0&id=65cfbcd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfbcd2",
  null
  
)

export default component.exports